import { BrowserRouter } from 'react-router-dom';
import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { get } from 'lodash';
import {
  useUnifyUserProfile,
  useUserProfile,
  useUpdateUserLastLogin,
  useIAMUserProfile,
  useApplications,
  useWorkflows,
  useWorkflowsViewMap,
  useGetAllApplications,
  useGetAllWorkflows,
  useUserSettings,
  useUpdateUserSettings,
  useCspUrls,
  useFetchDMS,
  useUpdateUserCNumber,
  useAdoptEaseConfig,
  useAdoptEaseUsageByUser,
  useFetchDMSBoxMapping,
} from '../../hooks/queries';
import {SSENotification} from '../SSE/NotificationReciever';
import * as Styles from '../styles';
import Header from '../Header/Header';
import SideSheetProvider from '../SideSheetProvider/SideSheetProvider';
import { SideSheet } from '../SideSheet/SideSheet';
import PaneManagementProvider from '../PaneManagementProvider/PaneManagementProvider';
import Routes from '../Routes';
import PaneManager from '../PaneManager/PaneManager';
import { useEffect, useState } from 'react';
import NotificationsDialog from '../Notifications/NotificationsDialog';
import {
  darkMode as RDSDarkMode,
  theme as RDSLightMode,
  Toast, TOAST_POSITIONS, TOAST_VISIBILITY_DURATIONS,
  BUTTON_VARIANTS, BUTTON_ICON_COLORS, IconCancelOutlined,
} from 'cdk-radial';
import { ThemeProvider } from 'styled-components';
import createOktaInstance from '../../config/okta';
import { OktaAuth } from '@okta/okta-auth-js';
import { AMPLITUDE_EVENTS, LOGOUT_URL, SPOKE_USERS, OKTA_LOGOUT_URL, testUsers} from '../../constants';
import getUserIdFromOkta from '../../util/getUserIdFromOkta';
import { LOGOUT_STATUS } from '../MessageProvider/MessageProvider';
import LogoutConfirmDialog from '../Dialogs/LogoutConfirmDialog';
import { useChannelMessage } from '../MessageProvider/MessageContext';
import { useTranslation } from 'react-i18next';
import  {useNotificationStore} from '../../Store';
import {useApplicationStore, 
  useWorkflowsStore, 
  useWorkflowsViewMapStore, 
  useAllApplicationsStore, 
  useAllWorkflowsStore,
  useIamUserProfileStore,
  useDriveCNumbersStore,
  useUserSettingsStore,
  useUnifyProfileStore,
  useUserIPRestrictionStore} 
  from '../../Store/index'
import Walkme from '../../components/Walkme/Walkme';
import BannerContainer from '../Banner/BannerContainer';
import moment from 'moment';
import OutageNotificationContainer from '../Notifications/OutageNotificationContainer';
import { useTheme } from '../../contexts/Theme';
import { CustomScrollbarWrapper } from 'cdk-radial';
import styled from "styled-components";
import { IAMRole, IAMStore, IAMUserInfo } from '../../types';
import getCdkSidFromOkta from '../../util/getCdkSidFromOkta';
import { useWillShowDialog } from '../../contexts/AppStateContext';
import CardMoreDialog from '../Cards/CardMoreDialog';
import useAudit from '../../hooks/useAudit';
import { useFeatureFlag } from '@harnessio/ff-react-client-sdk';
import { useFlagsEvaluatedForTarget } from '../../hooks/useFlagsEvaluatedForTarget';
import GetMobileAppDialog from '../Dialogs/GetMobileAppDialog';
import SessionExpiryDialog from '../Dialogs/SessionExpiryDialog';
import { useAdoptEaseStore, useRouteStore } from '../../Store';
import {IUserIPRestrictionEntity} from '../DealerAdmin/IPRestrictionInterface';
import { useUserIPRestriction } from '../DealerAdmin/useDealerAdminQueries';
import UnifyRestrictionDialog from './UnifyRestrictionDialog';
import {verifyAndEnableAdoptEaseApplications, verifyAndEnableAdoptEaseDrive} from '../../util/AdoptEaseUtils'
import AivaWrapper from '../Aiva/AivaWrapper';
import useAuthToken from '../../hooks/useAuthToken';
import { useUnifyVersion,useUnifyER } from '../../AppState';
import { ErrorBoundary } from '../../util/ErrorBoundary';
import StartupAppRedirect from '../StartupAppRedirect/StartupAppRedirect';
import { loadDynamicWalkmeScript } from '../Help/DynamicHelp';
import { useHelpStore } from '../Help/HelpStore';
import { useStartupToastStore } from '../../Store';
import StartupDriveLauncher from '../StartupAppRedirect/StartupDriveLauncher';
import { clearLocalStorageExceptDMS } from '../../util/clearLocalStorage';


export const StyledCustomScrollbarWrapper = styled(CustomScrollbarWrapper)`
  height: calc(100% - 50px);
  overflow-x: hidden;
`;

const AppLoader = (props :{loaderText:string}) => {
  return (
    <Styles.LoaderContainer data-testid='loader-container'>
      <Styles.Loader />
      <h3>{props.loaderText}</h3>
    </Styles.LoaderContainer>
  )
};

export const getDefaultStore = (userProfile:any) =>{
  const userDefaultStore = get(
    userProfile,
    'fullUser.stores',
    []
  ).find((store: IAMStore) => (store?.defaultStore === true)) || {};
  return userDefaultStore;
}

type HomeProps = {
  ffTargetReady?: boolean;
  ffTargetKey?: string;
};

export default function Home({ ffTargetReady = true, ffTargetKey = '' }: HomeProps) {
  const { data } = useUserProfile();
  const setApplications = useApplicationStore((state:any) => state.setApplications);
  const setApiStatus = useApplicationStore((state:any) => state.setApiStatus);
  const setIsFetched = useApplicationStore((state:any) => state.setIsFetched);
  const setWorkflows = useWorkflowsStore((state:any) => state.setWorkflows);
  const setWorkflowsApiStatus = useWorkflowsStore((state:any) => state.setApiStatus);
  const setWorkflowsIsFetched = useWorkflowsStore((state:any) => state.setIsFetched);
  const userWorkflows = useWorkflowsStore((state: any) => state.workflows);
  const setWorkflowsViewMap = useWorkflowsViewMapStore((state:any) => state.setWorkflowsViewMap);
  const setFavoriteWorkflowsViewMap = useWorkflowsViewMapStore((state:any) => state.setFavoriteWorkflowsViewMap);
  const setWorkflowsViewMapApiStatus = useWorkflowsViewMapStore((state:any) => state.setApiStatus);
  const setAllApplications = useAllApplicationsStore((state:any) => state.setApplications);
  const setAllWorkflows = useAllWorkflowsStore((state:any) => state.setWorkflows);
  const setIamUserInfo = useIamUserProfileStore((state:any) => state.setIamUserInfo);
  const setIamUserIsLoading = useIamUserProfileStore((state:any) => state.setIsLoading);
  const setIamUserIsError = useIamUserProfileStore((state:any) => state.setIsError);
  const setUserSettings = useUserSettingsStore((state:any) => state.setUserSettings);
  const setUnifyProfile = useUnifyProfileStore((state:any) => state.setUnifyProfile);
  const setUserSettingsStatus = useUserSettingsStore((state:any) => state.setApiStatus);
  const setIpRestriction = useUserIPRestrictionStore((state: any) => state.setIpRestriction);
  const { showToast, toastMsg, toastType, hideStartupToast } = useStartupToastStore();

  const oktaAuth = createOktaInstance() as OktaAuth;
  const { trackEvent, identify } = useAnalytics();
  const isAmplitudeEnabled = useFeatureFlag('UNIFY_UI_AMPLITUDE');

  const { data: userProfile, isLoading: iamLoading, isError: iamError, } = useIAMUserProfile();
  const { logoutStatus, setLogoutStatus, logoutProducts } = useChannelMessage();
  const [loaderText, setLoaderText] = useState('CDK Unify');
  const { t } = useTranslation();
  const { data: notificationsData } = [] as any;
  const {data: applications, isFetched, apiStatus} = useApplications();
  const {data: workflows, status: workflowApiStatus, isFetched: workflowsIsFetched} = useWorkflows();
  const {data: workflowsViewMap, status: workflowsViewMapStat} = useWorkflowsViewMap();
  const {data: favoriteWorkflowsViewMap} = useWorkflowsViewMap(true);
  
  const store = getDefaultStore(userProfile);

  const enterpriseId = get(data, "userProfile.enterpriseId", "")
  const { data: ipRestrictionData, isLoading: isIPRestrictionLoading } = useUserIPRestriction(
    enterpriseId, store?.id);
  const shouldNotificationRefresh = useNotificationStore((state: any) => state.shouldNotificationRefresh);
  const reset = useNotificationStore((state: any) => state.reset);
  const { data: allApplications } = useGetAllApplications();
  const { data: allWorkflows } = useGetAllWorkflows();
  const { data: userSettings, status: userSettingStatus } = useUserSettings();
  const { mutate:themeMutate } = useUpdateUserSettings();
  const { mutate } = useUpdateUserLastLogin();
  const { mutate : updateCNumber } = useUpdateUserCNumber();
  const {data:unifyProfile} = useUnifyUserProfile();
  const [notifyMessage, showNotification] = useState(false); 
  const { darkMode } = useTheme();
  const useSystemTheme =  localStorage.getItem('use-system-theme') === 'yes';
  const systemDarkTheme = window.matchMedia('(prefers-color-scheme: dark)')?.matches;
  const theme = darkMode ? RDSDarkMode : RDSLightMode;
  const aivaFlag = useFeatureFlag('UNIFY_UI_AIVA');
  const adoptEaseApplicationFlag = useFeatureFlag('UNIFY_UI_ADOPTEASE_APPLICATION');
  const adoptEaseDriveFlag = useFeatureFlag('UNIFY_UI_ADOPTEASE');
  const adoptEaseJournalEntryFlag = useFeatureFlag('UNIFY_UI_ADOPTEASE_JOURNALE');
  const adoptEaseCustomerFlag = useFeatureFlag('UNIFY_UI_ADOPTEASE_CUSTOMER');
  const adoptEaseVendorFlag = useFeatureFlag('UNIFY_UI_ADOPTEASE_VENDOR');
  const [ lastLoginInHandle, setLastLoginInHandle ] = useState(false);
  const [isTestUser, setIsTestUser] = useState(false);
  const { data: cspHeaders } = useCspUrls();
  const [isDriveUser, setDriveUser] = useState(false);
  const { data: dmsCNos, isFetching: cNumbersIsFetching } = useFetchDMS(isDriveUser);
  const { data: dmsBoxMappingData } = useFetchDMSBoxMapping(isDriveUser);
  const { captureEvent} = useAudit();
  const setCNumbers = useDriveCNumbersStore((state:any) => state.setCNumbers);
  const setCNumbersIsFetched = useDriveCNumbersStore((state:any) => state.setIsFetched);
  const setDmsBoxMapping = useDriveCNumbersStore((state:any) => state.setDmsBoxMapping);
  const [restrictApp, setRestrictApp] = useState(false);
  const [restrictMessage, setRestrictMessage] = useState<string>('');
  const setRoute =  useRouteStore((state:any) => state.setRoute);
  const route =  useRouteStore((state:any) => state.route);
  const hideBanner =  useRouteStore((state:any) => state.hideBanner);
  const setHideBanner =  useRouteStore((state:any) => state.setHideBanner);
  const UNIFY_UI_20 = useFeatureFlag("UNIFY_UI_20");
  const UNIFY_UI_ER = useFeatureFlag("UNIFY_UI_ER");
  const [paneStatus, setPaneStatus] = useState("");
  const setUnifyER = useUnifyER((state: any) => state.setUnifyER);
  const enableIdpProxyFlag = useFeatureFlag("UNIFY_ENABLE_IDP_PROXY");
  const setUnifyVersion = useUnifyVersion((state: any) => state.setUnifyVersion);
  const flagsEvaluatedForTarget = useFlagsEvaluatedForTarget(ffTargetKey);
  const canApplyVersionFlags = ffTargetReady && flagsEvaluatedForTarget;
  const { walkmeScript } = useHelpStore(
    (state: any) => state
  );
//AdoptEase
  const token = useAuthToken();
  const { data: adoptEaseConfig, isFetched: adoptEaseConfigIsFetched, status: adoptEaseConfigApiStatus } = useAdoptEaseConfig();
  const { data: adoptEaseUsageByUser, isFetched: adoptEaseUsageByUseIsFetched, status: adoptEaseUsageByUseApiStatus } = useAdoptEaseUsageByUser();
  const setAdoptEaseConfigData = useAdoptEaseStore((state: any) => state.setAdoptEaseConfigData);
  const setAdoptEaseUsageData = useAdoptEaseStore((state: any) => state.setAdoptEaseUsageData);
  const deepLinkProgress = useAllApplicationsStore((state:any) => state.deepLinkProgress);
  const [deepLinkText, setDeeLinkText] = useState('Verifying Link..');
  const [userPermissions, setUserPermissions] = useState<string[]>([]);
 
  useEffect(() => {
    if (applications){
      setApplications(applications);
      const deepLink = localStorage.getItem('deep-link-url');
      const deepLinkParams = deepLink?.substring(0, deepLink?.indexOf('/')).split('_') || '';
      const deepLinkAppId = deepLinkParams[0] === 'ap' ? deepLinkParams[1] : '';
      const app = applications.find(app => app.id === deepLinkAppId);
      app?.name && setDeeLinkText('Opening ' + (app?.name || '') + '..');
      const driveApp = applications.filter(app => app.id === "DMSDRIVE");
      driveApp.length > 0 && setDriveUser(true);
    }
    apiStatus && setApiStatus(apiStatus);
    setIsFetched(isFetched);
  }, [applications, setApplications, isFetched, apiStatus,
    setApiStatus, setIsFetched]);

  useEffect(()=>{
      if(!canApplyVersionFlags){
        return;
      }
      if(UNIFY_UI_20 === false){
        setUnifyVersion('v1')
      }
      if(UNIFY_UI_20 === true){
        setUnifyVersion('v2')
      }

      if(UNIFY_UI_ER === true){
        console.log("UNIFY_UI_ER from Unify ER to Unify",UNIFY_UI_ER)
        if (paneStatus?.length < 3){
          setUnifyER('true');
        }
      }
      if(UNIFY_UI_ER === false){
        console.log("UNIFY_UI_ER from Unify ER to Unify",UNIFY_UI_ER)
        setUnifyER('false')
      }

  },[canApplyVersionFlags, UNIFY_UI_20, UNIFY_UI_ER, setUnifyVersion, setUnifyER, paneStatus]);

  useEffect(() => {
  const checkStorage = () => {
    const val = localStorage.getItem('activePaneLoaded');
    setPaneStatus(val || "");
  };
  window.addEventListener('active-pane-changed', checkStorage);
  return () => window.removeEventListener('active-pane-changed', checkStorage);
}, []);

  useEffect(() => {
    const feedbackButton = document.querySelector(".QSIFeedbackButton") as HTMLElement | null;
    if (feedbackButton) {
        feedbackButton.style.display = "block";
    }
    const pullupContainer = document.querySelector("#QSIFeedbackButton-target-container") as HTMLElement | null;
    if (pullupContainer) {
        pullupContainer.style.display = "block"; 
    }
    const aivaWrapper = document.querySelector(".aiva-unify") as HTMLElement | null;
    if (aivaWrapper) {
        aivaWrapper.style.display = "block"; 
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]); 

  useEffect(() => {
    adoptEaseConfig && setAdoptEaseConfigData(adoptEaseConfig);
    adoptEaseUsageByUser && setAdoptEaseUsageData(adoptEaseUsageByUser);
  }, [adoptEaseConfig, adoptEaseConfigIsFetched, adoptEaseConfigApiStatus,
    adoptEaseUsageByUser, adoptEaseUsageByUseIsFetched, adoptEaseUsageByUseApiStatus,
    setAdoptEaseConfigData, setAdoptEaseUsageData
  ]);

  useEffect(() => {
    if (adoptEaseApplicationFlag && adoptEaseConfig && applications)
    {
      verifyAndEnableAdoptEaseApplications(adoptEaseConfig, applications, getUserIdFromOkta(), token);
    }
     // eslint-disable-next-line
  }, [
    adoptEaseApplicationFlag, adoptEaseConfig, applications, token
  ]);

  useEffect(() => {
   if (isDriveUser &&  (adoptEaseDriveFlag || adoptEaseJournalEntryFlag || adoptEaseCustomerFlag || adoptEaseVendorFlag) && adoptEaseConfig && userWorkflows)
    {
      verifyAndEnableAdoptEaseDrive(adoptEaseConfig, userWorkflows, getUserIdFromOkta(), token);
    }
    // eslint-disable-next-line
  }, [
    isDriveUser, adoptEaseDriveFlag, adoptEaseJournalEntryFlag, adoptEaseCustomerFlag, adoptEaseVendorFlag, adoptEaseConfig, userWorkflows, token
  ]);

  useEffect(() => {
    dmsCNos && setCNumbers(dmsCNos);
    setCNumbersIsFetched(cNumbersIsFetching);
  }, [dmsCNos, setCNumbers, setCNumbersIsFetched, cNumbersIsFetching]);

  useEffect(() => {
    dmsBoxMappingData && setDmsBoxMapping(dmsBoxMappingData);
  }, [dmsBoxMappingData, setDmsBoxMapping]);

  useEffect(() => {
    setWorkflowsApiStatus(workflowApiStatus)
    workflows && setWorkflows(workflows);
    setWorkflowsIsFetched(workflowsIsFetched);
    if(workflows) {
      const deepLink = localStorage.getItem('deep-link-url');
      const deepLinkParams = deepLink?.substring(0, deepLink?.indexOf('/')).split('_') || '';
      const deepLinkAppId = deepLinkParams[0] === 'wf' ? deepLinkParams[1] : '';
      const wflow = workflows.find(wf => wf.id === deepLinkAppId);
      wflow?.name && setDeeLinkText('Opening ' + (wflow?.name || '') + '..');
    }

  }, [workflows, setWorkflows, workflowApiStatus, setWorkflowsApiStatus, workflowsIsFetched, setWorkflowsIsFetched]);

  useEffect(() => {
    if(cspHeaders) {
      const meta = document.createElement('meta');
      meta.httpEquiv = "Content-Security-Policy";
      const metaUrls = cspHeaders?.whiteListedUrls?.reduce((acc, url) => { return acc += (' ' + url) }, '')
       meta.content = `upgrade-insecure-requests; child-src data: cdkdrive: microsoft-edge: msteams: blob: mailto: tel: com.cdk.servicebookpro: com.cdk.inspectpro:${metaUrls}`;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, [cspHeaders]);

  useEffect(() => {
    workflowsViewMap && setWorkflowsViewMap(workflowsViewMap);
    favoriteWorkflowsViewMap && setFavoriteWorkflowsViewMap(favoriteWorkflowsViewMap);
    workflowsViewMapStat && setWorkflowsViewMapApiStatus(workflowsViewMapStat);
  }, [workflowsViewMap, setWorkflowsViewMap, favoriteWorkflowsViewMap,
    setFavoriteWorkflowsViewMap, workflowsViewMapStat, setWorkflowsViewMapApiStatus]);

  useEffect(() => {
    allApplications && setAllApplications(allApplications);
    allWorkflows && setAllWorkflows(allWorkflows);
  }, [allApplications, setAllApplications, allWorkflows, setAllWorkflows]);

  useEffect(() => {
    userProfile && setIamUserInfo(userProfile)
    setIamUserIsLoading(iamLoading);
    setIamUserIsError(iamError);
  }, [userProfile, setIamUserInfo,
    iamLoading, setIamUserIsLoading,
    iamError, setIamUserIsError]);

  useEffect(() => {
    const settings = useSystemTheme  ? { theme: systemDarkTheme ? 'dark' : 'light' } : userSettings ;
    settings && setUserSettings(settings);
    settings?.theme !== userSettings?.theme && themeMutate( { theme: settings?.theme as 'dark' | 'light'} )
    setUserSettingsStatus(userSettingStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSettings, setUserSettings, setUserSettingsStatus, userSettingStatus]);

  useEffect(() => {
    unifyProfile && setUnifyProfile(unifyProfile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unifyProfile, setUnifyProfile]);

  useEffect(() => {
    if (data){
      const entitlements = get(data, 'userProfile.entitlements', []);
      const permissions = entitlements.map(item => Object.keys(JSON.parse(item))[0]);
      if(permissions) {
        setUserPermissions(permissions);
      }
      if(data?.lastLogin && unifyProfile && !iamLoading) {
        let isMutated = handleLastLoginDate(unifyProfile.lastLoggedIn,data.lastLogin, permissions);
        setLastLoginInHandle(isMutated);
      }
    }
    if(unifyProfile) {
      if(testUsers.indexOf(unifyProfile.loginId)>= 0) {
          setIsTestUser(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[unifyProfile, data, data?.lastLogin, iamLoading]);

  useEffect(() => {
    if (data && data.lastLogin && unifyProfile && isFetched && isDriveUser && dmsCNos){
      const cNumbers = dmsCNos.map(dms => dms.cNumber);
      updateCNumber({ cNumbers: cNumbers })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[unifyProfile, data?.lastLogin, isFetched, isDriveUser,dmsCNos ]);

  useEffect(() => {
    if (data && data?.locale){
      localStorage.setItem('userLocale', data?.locale); 
    }
  },[data]);

  useEffect(() => {
    if (lastLoginInHandle && 
        notificationsData && notificationsData.length > 0 && 
        notificationsData[0].type === 'outage' &&
        notificationsData[0].read === false
        && !shouldNotificationRefresh) {
          showNotification(true);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[lastLoginInHandle,notificationsData,shouldNotificationRefresh]);

  const handleLastLoginDate = (unifyProfileLastLoggedIn: Date,oktaProfileLastLoggedIn: Date,permissions: string[]) =>{
    let lastLoggedInDate = moment.utc(unifyProfileLastLoggedIn,'dddd, MMMM DD, YYYY at h:mm:ss A Z');
    let oktaLoggedInDate = moment.utc(oktaProfileLastLoggedIn,'YYYY-MM-DDThh:mm:ss A Z');

    if (!lastLoggedInDate.isSame(oktaLoggedInDate)){

      const cdksid = getCdkSidFromOkta();
      const enterpriseId = userProfile?.fullUser
      ? userProfile?.fullUser?.enterprise?.id 
      : !cdksid ?  SPOKE_USERS : null;
      reset(true);
      mutate({ lastLogin: oktaProfileLastLoggedIn, enterpriseId, storeId: store?.id, permissions:permissions });
      trackEvent(AMPLITUDE_EVENTS.SINGLE_LOGIN_UNIFY);
      return true;
    }
    return false;
  }

  const handleLogout = () => {
    logoutProducts();
  };

  const signOutUnify = () => {
    trackEvent(AMPLITUDE_EVENTS.LOGOUT_UNIFY,{'Action': 'Confirmed'});
    captureEvent({action :"Logout"});
    const idToken = oktaAuth.getIdToken();
    executeSignOut(idToken);
  };

  const unifyAppRestrictedLogout = () => {
    trackEvent(AMPLITUDE_EVENTS.LOGOUT_UNIFY,{'Action': 'Unify App Restricted Logout'});
    captureEvent({action :"Unify App Restricted Logout"});
    const idToken = oktaAuth.getIdToken();
    executeSignOut(idToken);
  };

  useEffect(()=>{
    if(ipRestrictionData){
      setIpRestriction(ipRestrictionData);
      const unifyAppRestriction = ipRestrictionData?.find(
        (entity: IUserIPRestrictionEntity) => entity.entityId === 'UNIFY' && entity.isRestricted
      );
      const message = unifyAppRestriction?.message;
      setRestrictMessage(message || '');
      setRestrictApp(!!unifyAppRestriction);
    }
  },[ipRestrictionData,setIpRestriction]);

  useEffect(() => {
    try {
      if (!iamLoading) {
        const userId = getUserIdFromOkta();
        const cdksid = getCdkSidFromOkta();

        const enterpriseId = userProfile?.fullUser
          ? userProfile?.fullUser?.enterprise?.id
          : !cdksid ? SPOKE_USERS : null;

        let enterpriseName = userProfile?.fullUser ? ` ${userProfile?.fullUser?.enterprise?.name}` : ``;
        if (userId && enterpriseId && applications?.length >0 && workflows && workflows?.length >0) {
          const userRoles = get(
            userProfile,
            'fullUser.roles',
            []
          ).map((role: IAMRole) => role.roleName);

          if(isAmplitudeEnabled){
            identify({
              'user_id': userId,
              'user_role': userRoles,
              'enterprise_id': enterpriseId,
              'enterprise_name': enterpriseName,
              'store_id': (store as IAMStore)?.id,
              'store_name': (store as IAMStore)?.name,
              'stores': userProfile?.fullUser?.stores.map(({ id, name }) => `${id} ${name}`),
              'applications':applications?.map((app: any) => app?.name),
              'workflows':workflows?.map((app: any) => app?.name)
            });
            trackEvent(AMPLITUDE_EVENTS.LOGIN_UNIFY);
            trackEvent(AMPLITUDE_EVENTS.VIEW_UNIFY_PAGE);
          }else{
            identify({
              'User ID': userId,
              'Enterprise ID': enterpriseId,
              'User role': userRoles,
              'Stores': userProfile?.fullUser?.stores.map(({ id, name }) => `${id} ${name}`),
              'Store Id': (store as IAMStore)?.id,
              'Enterprise Name': enterpriseId + enterpriseName,
              'Store Name': (store as IAMStore)?.id + ` ${(store as IAMStore)?.name}`,
            });
            trackEvent(AMPLITUDE_EVENTS.LOGIN_UNIFY);
            trackEvent(AMPLITUDE_EVENTS.VIEW_UNIFY_PAGE);   
          }
        }
      }
    } catch (err) { }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userProfile, iamLoading,applications,workflows,isAmplitudeEnabled]);


  useEffect(() => {
    if (logoutStatus === LOGOUT_STATUS.APPS_COMPLETE) {
      const logoutMsg = t('home.logoutUnify');
      setLoaderText(logoutMsg);
      signOutUnify();
    } else if (logoutStatus === LOGOUT_STATUS.LOGOUT_PROGRESS) {
      const logoutMsg = t('home.logoutApplications');
      setLoaderText(logoutMsg);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logoutStatus]);

  useEffect(() => {
    const handleFeedbackClick = (evt: MouseEvent) => {
      try {
        const feedbackButton = (evt.target as HTMLElement).parentElement;
        if (
          feedbackButton?.id === 'QSIFeedbackButton-btn' &&
          feedbackButton.getAttribute('aria-expanded') === 'true'
        ) {
          trackEvent(AMPLITUDE_EVENTS.OPEN_FEEDBACK);
        }
      } catch (err) {
        console.warn('Amplitude - Feedback Tracking error', err);
      }
    };
    document.addEventListener('click', handleFeedbackClick); 
    return () => {
      document.removeEventListener('click', handleFeedbackClick);
    };
  }, [trackEvent]);

  const handleBackButton = () => {
    if (route ==='/pulse' ||
      route === '/admin' ||
      route === '/dealer-admin' ||
      route === '/global-search' ||
      route === '/global-search-history' 
    ) {
      if(window.location.pathname !== '')
      {
      setRoute(window.location.pathname);
      }
      else{
        setRoute('/applications');
      }
    } 
  };

  window.addEventListener('popstate', handleBackButton);

  const previousRoute =  useRouteStore((state:any) => state.previousRoute);
  
  useEffect(() => {
    const adminPath = /^\/admin/;
    const pulsePath = /^\/pulse/;
    const dealerAdminPath = /^\/dealer-admin/;
    const globalSerachPath = /^\/global-search/;
    const globalSearchHistoryPath = /^\/global-search-history/;
    if (route === '/pulse' || route === '/dealer-admin' || route === '/global-search' || route === '/global-search-history' || adminPath.test(window.location.pathname)
      || pulsePath.test(window.location.pathname)
      || dealerAdminPath.test(window.location.pathname)
      || globalSerachPath.test(window.location.pathname)
      || globalSearchHistoryPath.test(window.location.pathname)) {
      setHideBanner(true);
    }
    else
    {setHideBanner(false);}

    if(previousRoute === '')
      {setHideBanner(false)}

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[route,window.location.pathname,previousRoute]);

/***  Dialog Management   */
  const [ dialogData, setDialogData ] = useState({type:'none',isOpen:false});
  const willShowDialog = useWillShowDialog();
  willShowDialog( (type: string, data: any) => {
    setDialogData({...data, isEnabled: true, isFavorite: true, isIconRequired: true, onClose:() => setDialogData({type: 'none',isOpen:false}),  isOpen: type === 'LEARN_MORE'});
  });
/***  Dialog Management End  */

   useEffect(() => {
    const feedbackButton = document.querySelector(".QSIFeedbackButton") as HTMLElement | null;
    if (feedbackButton) {
      if (window.location.pathname  === "/admin" || window.location.pathname  === "/pulse" || window.location.pathname  === "/global-search" ) {
        feedbackButton.style.display = "none";
      } else {
        feedbackButton.style.display = "flex";
      }
    }

    const pullupContainer = document.querySelector("#QSIFeedbackButton-target-container") as HTMLElement | null;
        if (pullupContainer) {
          if (window.location.pathname  === "/admin" || window.location.pathname  === "/pulse" ) {
            pullupContainer.style.display = "none"; 
          } else {
            pullupContainer.style.display = "flex";
          }
        }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]); 

  useEffect(() => {
    let timeoutId: any;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        trackEvent(AMPLITUDE_EVENTS.SCREEN_RESIZED, { 'Height': window.innerHeight, 'Width': window.innerWidth, 'Resolution': `${window.innerWidth}x${window.innerHeight}` });
      }, 300);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line
  }, []);


  useEffect(() => {
    if (walkmeScript) {
      try{
        loadDynamicWalkmeScript("unify",walkmeScript);
      }catch(e){
        console.warn("Walkme script failed to load", e);
      }
    }
  }, [walkmeScript]);

  const handleSessionExpiryContinue = () => {
    oktaAuth.tokenManager.clear();
    clearLocalStorageExceptDMS();
    oktaAuth.signOut();
  };

  function executeSignOut(idToken: string | undefined) {
    if (!idToken) {
      oktaAuth.tokenManager.clear();
      clearLocalStorageExceptDMS();
      window.location.assign(`${LOGOUT_URL}?source=unify`);
      return;
    }
    if (enableIdpProxyFlag) {
      let unifyLogoutCallbackUrl = window.location.origin + '/logout/callback';
      const oktaDomainLogoutPath = `${OKTA_LOGOUT_URL}?id_token_hint=${encodeURIComponent(String(idToken))}&post_logout_redirect_uri=${encodeURIComponent(unifyLogoutCallbackUrl)}`;
      window.location.assign(oktaDomainLogoutPath);
      return;
    } else {
      oktaAuth.tokenManager.clear();
      clearLocalStorageExceptDMS();
      oktaAuth.signOut({
        postLogoutRedirectUri: `${LOGOUT_URL}?source=unify&id_token_hint=${encodeURIComponent(String(idToken))}`
      });
    }
  }

  return (
    <>
    <ThemeProvider theme={theme}>
   
    {(isIPRestrictionLoading || iamLoading) && (<AppLoader loaderText={loaderText} />)}
    {(deepLinkProgress) && (<AppLoader loaderText={deepLinkText as any} />)}
    <UnifyRestrictionDialog
                  message={restrictMessage}
                  isOpen={restrictApp}
                  onClose={unifyAppRestrictedLogout}/>

    <SessionExpiryDialog
                  isOpen={!isIPRestrictionLoading && !iamLoading && !!iamError}
                  onContinue={handleSessionExpiryContinue}/>

    {!restrictApp && !isIPRestrictionLoading  && !iamLoading && !iamError && (
        <PaneManagementProvider>
          <StartupAppRedirect />
          <StartupDriveLauncher />
          {(logoutStatus === LOGOUT_STATUS.LOGOUT_PROGRESS ||
            logoutStatus === LOGOUT_STATUS.APPS_COMPLETE) && <AppLoader loaderText={loaderText}/>}
          <SideSheetProvider>
            <Styles.Backplane id="backplane">
            { userProfile && isFetched &&<SSENotification userProfile={userProfile}/> }
              <Header />
              <StyledCustomScrollbarWrapper id="custom-scrollbar-wrapper">
                { !hideBanner && <OutageNotificationContainer/>  }
                {!hideBanner && (
                    <BannerContainer/>
                    )}
                <Styles.BackplaneBodyWrapper>
                <Styles.BackplaneBody
                    id="backplane-body"
                    isAdmin={hideBanner}
                    margin={'5px 0px'}
                  >
                    <BrowserRouter>
                      <Routes />
                    </BrowserRouter>
                    <PaneManager />
                  </Styles.BackplaneBody>
                </Styles.BackplaneBodyWrapper>
                <SideSheet />
              </StyledCustomScrollbarWrapper>
            </Styles.Backplane>
                <NotificationsDialog
                  isOpen={notifyMessage}
                  onClose={() => showNotification(false)} />
              <LogoutConfirmDialog
                isOpen={logoutStatus === LOGOUT_STATUS.LOGOUT_INIT}
                data-testid="logout_dialog"     
                onLogout={handleLogout}
                onCancel={() => setLogoutStatus(LOGOUT_STATUS.NONE)}
              />
              <GetMobileAppDialog  data-testid="get_mobile_app_dialog" ></GetMobileAppDialog>
              <CardMoreDialog cardData={dialogData} />              
               {aivaFlag && 
                <ErrorBoundary>
                    <AivaWrapper
                      oktaAuth={oktaAuth}
                      userProfile={userProfile as IAMUserInfo}
                      darkMode={darkMode as boolean}
                      userApplications={applications?.map((item) => { return { appId: item.id, name: item.name }})}
                      permissions={userPermissions}
                    /></ErrorBoundary>
                }
                {showToast && (
                <Toast
                  id="startup-app-toast"
                  datatestid="startup-app-toast"
                  position={TOAST_POSITIONS.FIXED}
                  style={{ marginTop: '70px', zIndex: 1003 }}
                  variant={toastType}
                  visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
                  onVisibilityDurationEnd={hideStartupToast}
                  actions={[{
                    onClick: hideStartupToast,
                    variant: BUTTON_VARIANTS.ICON,
                    icon: <IconCancelOutlined />,
                    iconColor: BUTTON_ICON_COLORS.GRAY,
                    text: '',
                  }]}
                  content={toastMsg}
                />
              )}
          </SideSheetProvider>
        </PaneManagementProvider>
      )}
      {!isTestUser &&
      <div id="walkme-pane" data-testid="walkme-pane" ><Walkme></Walkme></div>
      }
      

      </ThemeProvider>
    </>
  );
}
